<template>
  <div>
    <Title v-if="!isAdmin" :showMinister="true" :showService="true" />

    <Breadcrumb :links="breadCrumbData" />
    <Carrusel />

    <h3 class="text-indicator">Compromisos</h3>

    <Main :listData="listData" :tablesData="tablesData" />
  </div>
</template>

<script>
import Title from "../../../components/private/Title";
import Breadcrumb from "@/components/tools/Breadcrumb.vue";
import { mapState } from "vuex";
import Carrusel from "../../../components/private/Carrusel.vue";
import Main from "./Main.vue";
// import NoPerms from "./NoPerms.vue";
import axios from "axios";
export default {
  components: {
    Title,
    Breadcrumb,
    Carrusel,
    Main,
    // NoPerms,
  },
  computed: {
    ...mapState("sesion", ["usuario"]),
    isAdmin: function() {
      return this.usuario.username === process.env.VUE_APP_USER_ADMIN;
    },
  },
  data() {
    return {
      breadCrumbData: null,
      listData: [],
      tablesData: false,
      anexosPut: null,
    };
  },
  methods: {
    setBreadcrumbData: function() {
      this.breadCrumbData = [
        {
          name: "Portada BGI",
          routeName: "bgi",
          routeParams: {
            idUsuario: this.usuario.id,
          },
        },
        {
          name: "Escritorio de Gestión Virtual",
          routeName: "buttons",
          routeParams: {
            idUsuario: this.usuario.id,
            idServicio: this.$route.params.idServicio,
          },
        },
        {
          name: "Compromisos",
          routeName: "compromisos",
          routeParams: {
            idServicio: this.$route.params.idServicio,
          },
        },
      ];
    },
    obtenerRelacionUsuarioServicio() {
      const data = JSON.parse(localStorage.getItem("user"));
      const relacionUs = data.servicios.find(
        (s) => s.id === parseInt(this.$route.params.idServicio)
      );
      if (!relacionUs) return;
      if (
        relacionUs.permisos.find((p) => p.permisoId === 8) ||
        relacionUs.rolId === 3 ||
        relacionUs.rolId === 4 ||
        relacionUs.rolId === 5
      ) {
        this.permission = true;
      }
    },
    obtenerContenido: async function() {
      try {
        // const anio = process.env.VUE_APP_ANIO;
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/anexos/anexo/public_list/?anexo=5&servicio=${this.$route.params.idServicio}`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );

        console.log("dataaaaa", res.data);
        const data = res.data[0].datos.original;
        let years = Object.keys(data);

        years.forEach((y) => {
          this.listData.push(...data[y]);
        });

        if (this.listData.length < 50) {
          this.tablesData = false;
        } else if (this.listData.length === 0) {
          this.tablesData = false;
        } else {
          this.tablesData = true;
        }

        this.anexoPut = res.data[0].datos.modificado["2022"][0];

        console.log("anexo", this.anexoPut);
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.setBreadcrumbData();
    this.obtenerContenido();
    this.obtenerRelacionUsuarioServicio();
  },
};
</script>

<style scoped>
.text-indicator {
  text-align: center;
  font-weight: bold;
}
</style>
